<div [attr.id]="id" class="container" [class]="tagType">
  <ng-content></ng-content>
</div>
